<template>
  <hm-content title="">
    <hm-step :steps="steps" :scroll="true" :step="currentStep"></hm-step>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
    >
      <div v-if="currentStep === 1">
        <div >
          <el-form-item label="目标内容" prop="drawName">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              maxlength="38"
              v-model.trim="ruleForm.drawName"
              placeholder="请输入目标内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="目标金额" prop="drawPrice">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              maxlength="38"
              @change="drawPricechange"
              v-model.trim="ruleForm.drawPrice"
              @input="filterGt0OrFixed2('drawPrice')"
              placeholder="请输入目标金额"
            ></el-input>
            <span v-if="money">{{ money }} </span>
          </el-form-item>
          <el-form-item label="目标年份" prop="drawDate">
            <el-select
              size="small"
              clearable
              placeholder="选择目标年份"
              v-model="ruleForm.drawDate"
              class="mr10"
              filterable
            >
              <el-option
                v-for="(item, i) in yearList"
                :key="i"
                :label="item.year"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-date-picker
              type="year"
              value-format="yyyy"
              v-model="ruleForm.drawDate"
              placeholder="请选择年份"
              size="small"
              class="mr10"
              @change="drawDatechange"
              @blur="drawDateblur"
              @focus="drawDatefocus"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </el-date-picker> -->
          </el-form-item>

          <el-form-item label="负责人" prop="drawNamerrr">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              maxlength="38"
              v-model.trim="ruleForm.drawNamerrr"
              placeholder="请输入负责人"
            ></el-input>
          </el-form-item>

          <el-form-item label="OKR商品" prop="drawGoods">
            <el-input
              disabled
              @focus="dialogVisible = true"
              size="small"
              class="mr10 ipt"
              v-model.trim="ruleForm.drawGoods"
              placeholder="请选择OKR商品"
            ></el-input>
            <el-button
              size="small"
              type="text"
              @click="dialogVisible = true"
              v-if="ruleForm.drawGoods === ''"
              :disabled="ruleForm.drawDate === ''"
              >新增</el-button
            >
            <el-button size="small" type="text" v-else @click="del"
              >删除</el-button
            >
          </el-form-item>
        </div>

        <!-- <el-form-item label="总目标名称：" prop="drawName">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            maxlength="38"
            v-model.trim="ruleForm.drawName"
            placeholder="请输入总目标名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="总目标金额：" prop="drawPrice">
          <el-input
            type="number"
            size="small"
            clearable
            class="mr10 ipt"
            maxlength="38"
            v-model.trim="ruleForm.drawPrice"
            placeholder="请输入总目标金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="目标起止时间：" prop="drawDate">
          <el-date-picker
            size="small"
            v-model="ruleForm.drawDate"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="拆分目标：">
           <el-button size="small" type="primary"  @click="addChild">新增子目标</el-button>
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 600px;"
          >
            <div v-for="(v, i) in list" :key="i">
              <div class="flex mt40" >
                <div class="mr10">
                  {{ "子目标" + (i + 1) }}:
                  <el-input
                    size="small"
                    clearable
                    class="mr10 ipt"
                    maxlength="38"
                    v-model.trim="v.drawName"
                    placeholder="请输入子目标名称"
                  ></el-input>
                </div>
                <div class="mr10">
                  目标金额：
                  <el-input
                    type="number"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    maxlength="38"
                    v-model.trim="v.drawPrice"
                    placeholder="请输入总目标金额"
                  ></el-input>
                </div>
                <div class="mr10">
                  负责人：
                  <el-input
                    size="small"
                    clearable
                    class="mr10 ipt"
                    maxlength="38"
                    v-model.trim="v.name"
                    placeholder="请输入负责人"
                  ></el-input>
                </div>

                <div class="flex item-center">
                  <div class="minus-wrapper flex flex-center" >
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteChild(i)"
                    ></span>
                  </div>
                </div>
              </div>
              <div>
                <el-table
                  :data="v.tableData"
                  row-key="id"
                  border
                  ref="table"
                  :header-cell-style="{
                    background: '#E4E4E4',
                    color: '#606266',
                  }"
                >
                  <el-table-column
                    v-show="tableHeader.length"
                    v-for="(col, index) in tableHeader"
                    :key="index"
                    min-width="200px"
                    :prop="col.columnName"
                    :label="col.labelName"
                    :column-key="index.toString()"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="number"
                        size="small"
                        clearable
                        class="mr10 ipt"
                        maxlength="38"
                        style="width: 150px"
                        v-model.trim="scope.row[col.columnName]"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-scrollbar>
        </el-form-item> -->

        <div v-if="ruleForm.drawGoods!==''">
          <hm-okr-table ref="hmorktable" :data="tableData"> </hm-okr-table>
        </div>
      </div>
      <div v-if="currentStep === 2">
        <div class="flex flex-around mb10 item-center" style="width: 420px">
          <div class="mr10">当前门店数：{{ shopList.length }}</div>
          <div>
            剩余比例（%）:
            <span :class="surplusVal < 0 ? 'danger' : ''">{{
              surplusVal
            }}</span>
          </div>
          <div>
            <el-button size="small" type="primary">保留比例</el-button>
          </div>
        </div>
        <el-table
          stripe
          border
          ref="table"
          :data="shopList"
          style="width: 400px"
          size="small"
          height="600"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shoppp"
            label="比例（%）"
            width="200"
          >
            <template slot-scope="scope">
              <el-input
                size="small"
                clearable
                style="width: 150px"
                class="mr10 ipt"
                v-model.trim="scope.row.shoppp"
                @change="surplusValChange(scope.$index, scope.row)"
                @focus="surplusValFocus(scope.$index, scope.row)"
                @blur="surplusValFocus(scope.$index, scope.row)"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="currentStep === 3">
        <div class="flex flex-around mb10 tip">
          <div>奶粉年销售突破3000万</div>
          <div>2020年</div>
          <div>30000000</div>
        </div>
        <hm-okr-table-shop :data="tableData"> </hm-okr-table-shop>
      </div>
      <div class="flex flex-center">
        <el-button size="small" type="primary" @click="currentStep--"
          >上一步</el-button
        >
        <el-button size="small" type="primary" @click="next">去分配</el-button>
        <el-button size="small" type="info" @click="cancel">取 消</el-button>
      </div>
    </el-form>

    <hm-shop-goods-okr
      type="microShop"
      :targeYear="ruleForm.drawDate"
      :visible="dialogVisible"
      @saveGoods="saveGoods"
      @close="dialogVisible = false"
    ></hm-shop-goods-okr>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import HmOkrTable from "@/components/HmOkrTable";
import HmShopGoodsOkr from "@/components/HmShopGoodsOkr";
import HmOkrTableShop from "@/components/HmOkrTableShop";
// import { numberChinese, toMoney } from "@/utils/utils";
export default {
  components: { HmStep, HmOkrTable, HmShopGoodsOkr, HmOkrTableShop },
  data() {
    return {
      tableHeader: [
        {
          labelName: "1月",
          columnName: "month1"
        },
        {
          labelName: "2月",
          columnName: "month2"
        }
      ],
      list: [
        {
          tableData: []
        }
      ],
      shopList: [
        {
          shopName: "是是是",
          shoppp: ""
        },
        {
          shopName: "放放放",
          shoppp: ""
        },
        {
          shopName: "是的哇对我",
          shoppp: ""
        },
        {
          shopName: "的伟大伟大",
          shoppp: ""
        }
      ],
      tableData: [
        // {
        //   parent: 1,
        //   id: 11,
        //   date: "2016-05-01",
        //   name: "9000000",
        //   address: "上海市普陀区金沙江路 1519 弄",
        //   month1: 1,
        //   month2: 2,
        //   month3: 3,
        //   month4: 4,
        //   month5: 5,
        //   month6: 6,
        //   month7: 7,
        //   month8: 8,
        //   month9: 9,
        //   month10: 10,
        //   month11: 11,
        //   month12: 12,
        //   children: [
        //     {
        //       parent: 2,
        //       id: 21,
        //       date: "2016-05-01",
        //       name: "300000",
        //       address: "上海市普陀区金沙江路 1519 弄",
        //       month1: 1,
        //       month2: 2,
        //       month3: 3,
        //       month4: 4,
        //       month5: 5,
        //       month6: 6,
        //       month7: 7,
        //       month8: 8,
        //       month9: 9,
        //       month10: 10,
        //       month11: 11,
        //       month12: 12,
        //       children: []
        //     },
        //     {
        //       parent: 2,
        //       id: 22,
        //       date: "2016-05-01",
        //       name: "100000",
        //       address: "上海市普陀区金沙江路 1519 弄",
        //       month1: 1,
        //       month2: 2,
        //       month3: 3,
        //       month4: 4,
        //       month5: 5,
        //       month6: 6,
        //       month7: 7,
        //       month8: 8,
        //       month9: 9,
        //       month10: 10,
        //       month11: 11,
        //       month12: 12,
        //       children: [
        //         {
        //           parent: 3,
        //           id: 31,
        //           date: "2016-05-0222",
        //           name: "20000",
        //           address: "上海市普陀区金沙江路 1519 弄",
        //           month1: 1,
        //           month2: 2,
        //           month3: 3,
        //           month4: 4,
        //           month5: 5,
        //           month6: 6,
        //           month7: 7,
        //           month8: 8,
        //           month9: 9,
        //           month10: 10,
        //           month11: 11,
        //           month12: 12,
        //           children: []
        //         },
        //         {
        //           parent: 0,
        //           id: 243,
        //           date: "其他",
        //           name: 0,
        //           address: "上海市普陀区金沙江路 2221519 弄",
        //           month1: 1,
        //           month2: 2,
        //           month3: 3,
        //           month4: 4,
        //           month5: 5,
        //           month6: 6,
        //           month7: 7,
        //           month8: 8,
        //           month9: 9,
        //           month10: 10,
        //           month11: 11,
        //           month12: 12,
        //           children: []
        //         }
        //       ]
        //     },
        //     {
        //       parent: 0,
        //       id: 23,
        //       date: "其他",
        //       name: 0,
        //       address: "上海市普陀区金沙江路 2221519 弄",
        //       children: []
        //     }
        //   ]
        // }
      ],

      dialogVisible: false,
      currentStep: 1,
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() < Date.now() - 8.64e7;
        // }
      },
      ruleForm: {
        drawDate: "",
        drawGoods: ""
      },
      rules: {},
      steps: [
        {
          id: "base",
          name: "制定目标计划"
        },
        {
          id: "gameRule",
          name: "分配门店占比"
        },
        {
          id: "gameAstrict",
          name: "预览门店商品"
        }
      ],
      surplusVal: 0,
      drawDate: "",
      drawDateChange: true,
      money: 0,
      yearList: [],
      other: {
        name: "其他",
        month1: "",
        month2: "",
        month3: "",
        month4: "",
        month5: "",
        month6: "",
        month7: "",
        month8: "",
        month9: "",
        month10: "",
        month11: "",
        month12: ""
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.tableHeader = [];
    for (let i = 1; i <= 12; i++) {
      this.tableHeader.push({
        labelName: i + "月",
        columnName: "month" + i
      });
      // this.queryAllShop();
    }
    this.list[0].tableData.push(Object.assign({}, this.other));
  },
  mounted() {
    this.queryAllShop();
    for (let i = 1; i < 10; i++) {
      this.yearList.push({
        year: new Date().getFullYear() + i + "年",
        value: new Date().getFullYear() + i + ""
      });
      // this.queryAllShop();
    }
  },
  methods: {
    addChild() {
      let tableData = [];
      tableData.push(Object.assign({}, this.other));

      this.list.push({
        tableData
      });
    },
    deleteChild(i) {
      this.list.splice(i, 1);
    },
    next() {
      this.currentStep++;
      // if (this.$refs.hmorktable.show) {
      //   this.$confirm(
      //     "未拆分KR月目标,若确定不拆分则按当前权重值智能填充",
      //     "提示",
      //     {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       type: "warning"
      //     }
      //   )
      //     .then(() => {
      //       console.log("确定");
      //     })
      //     .catch(() => {
      //       console.log("取消");
      //     });
      // } else {
      //   console.log(this.tableData);
    },
    del() {
      this.$confirm("修改父级会删除下面所有已选子级,是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.tableData = [];
          this.ruleForm.drawGoods = "";
        })
        .catch(() => {});
    },
    //将数行结构平铺
    treeConvertToArr(tree) {
      let arrs = [];
      let result = [];
      arrs = arrs.concat(tree);
      while (arrs.length) {
        let first = arrs.shift(); // 弹出第一个元素
        if (first.children) {
          //如果有children
          arrs = arrs.concat(first.children);
          delete first["children"];
        }
        result.push(first);
      }
      return result;
    },
    async queryAllShop() {
      const { result } = await this.$store.dispatch("queryAllShop");
      if (result.length) {
        result.forEach(v => {
          // let num = 100 / this.shopList.length;
          // v.shoppp = Math.floor(num * 100) / 100;
          v.shoppp = 0;
        });
        this.shopList = result;
        this.shopList = [...this.shopList];
        this.querySurplusVal();
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    drawPricechange(val) {
      if (this.tableData.length > 0) {
        this.tableData[0].total = val;

        // this.$set(this.tableData, 0, this.tableData[0]);
        // setTimeout(() => {
        //   this.$refs.hmorktable.queryDiff(this.tableData[0]);
        // }, 10);
      }
      // console.log(numberChinese(val));
      // this.money = toMoney(val);
      // console.log(toMoney(val));
    },
    cancel() {
      // let list = JSON.parse(JSON.stringify(this.tableData));
      // console.log(this.treeConvertToArr(list));

      this.$confirm("当前已为您自动保存数据，是否要保留?", "提示", {
        confirmButtonText: "保留",
        cancelButtonText: "不保留",
        distinguishCancelAndClose: true,
        type: "warning"
      })
        .then(() => {
          // console.log("保留");
        })
        .catch(action => {
          if (action === "cancel") {
            // console.log("不保留");
          } else {
            // console.log("取消");
          }
        });
    },
    drawDatefocus() {
      if (this.ruleForm.drawDate === "" || !this.ruleForm.drawDate) {
        this.drawDateChange = true;
      } else {
        this.drawDateChange = false;
      }
    },
    drawDateblur() {
      //this.drawDate = JSON.push(JSON.stringify(this.ruleForm.drawDate));
      // console.log(this.drawDateChange);
    },
    drawDatechange() {
      // this.drawDate = JSON.push(JSON.stringify(this.ruleForm.drawDate));
      // console.log(this.drawDateChange);
      if (!this.drawDateChange) {
        if (this.drawDate !== this.ruleForm.drawDate) {
          this.$confirm("修改年份会导致XXXXXX，是否确定修改?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.drawDate = JSON.parse(
                JSON.stringify(this.ruleForm.drawDate)
              );
            })
            .catch(() => {
              this.ruleForm.drawDate = JSON.parse(
                JSON.stringify(this.drawDate)
              );
            });
        }
      } else {
        // console.log(this.ruleForm.drawDate);
        this.drawDate = JSON.parse(JSON.stringify(this.ruleForm.drawDate));
      }
    },
    surplusValChange(i, v) {
      this.querySurplusVal();
      this.$set(this.shopList, i, v);
    },
    surplusValFocus(i, v) {
      this.$set(this.shopList, i, v);
      v.shoppp = new Number(v.shoppp);
    },
    //查询剩余比列
    querySurplusVal() {
      let total = 0;
      this.shopList.forEach(v => {
        total += v.shoppp * 1;
      });
      this.surplusVal = Math.floor((100 - total) * 100) / 100;
    },
    saveGoods(data) {
      if (this.tableData.length === 0) {
        // console.log(data);
        this.ruleForm.drawGoods = data.name;
        data.parent = 1;
        data.total = this.ruleForm.drawPrice;
        this.tableData.push(Object.assign({}, data));
        // this.$set(this.tableData, 0, this.tableData[0]);
        // console.log(this.tableData);
      }
      this.dialogVisible = false;
      // if (data.rightData.length > 0) {
      //   if (this.goodsType === "") {
      //     this.goodsType = data.goodsType;
      //   } else {
      //     if (this.goodsType !== data.goodsType) {
      //       this.goodsType = data.goodsType;
      //       this.rewardGoodList = data.rightData;
      //     }
      //   }

      //   data.rightData.forEach(v => {
      //     let show = false;
      //     this.rewardGoodList.forEach(item => {
      //       if (item.spuId === v.spuId) {
      //         show = true;
      //       }
      //     });
      //     if (!show) {
      //       this.rewardGoodList.push(v);
      //     }
      //   });

      //   this.dialogVisible = false;
      // } else {
      //   this.$message({
      //     message: "请选择商品",
      //     type: "warning"
      //   });
      // }
    }
  }
};
</script>
<style lang='scss' scoped>
.tip {
  font-weight: bold;
  font-size: 16px;
}
</style>
